export default __webpack_public_path__ + "static/media/chev-right-purple-btn.216a4171.svg";